module.exports = __webpack_public_path__ + "img/icon-over-manejo-libros.640c5f2b.svg";